import React, { createContext, useState, useEffect } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [companyEmail, setCompanyEmail] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ Load stored session when app starts
  useEffect(() => {
    const loadStoredSession = async () => {
      try {
        const storedData = await AsyncStorage.getItem("companySession");
        if (storedData) {
          const { id, name, email } = JSON.parse(storedData);
          setCompanyId(id);
          setCompanyName(name);
          setCompanyEmail(email);
          console.log("✅ Loaded persistent company session:", name);
        }
      } catch (error) {
        console.error("Error loading company session:", error);
      } finally {
        setLoading(false);
      }
    };

    loadStoredSession();
  }, []);

  // ✅ Save session on login
  const loginCompany = async (id, name, email) => {
    try {
      const sessionData = { id, name, email };
      await AsyncStorage.setItem("companySession", JSON.stringify(sessionData));
      setCompanyId(id);
      setCompanyName(name);
      setCompanyEmail(email);
      console.log("✅ Company session stored:", name);
    } catch (error) {
      console.error("Error saving company session:", error);
    }
  };

  // ✅ Clear session on logout
  const logoutCompany = async () => {
    try {
      await AsyncStorage.removeItem("companySession");
      setCompanyId(null);
      setCompanyName(null);
      setCompanyEmail(null);
      console.log("🚪 Company logged out");
    } catch (error) {
      console.error("Error logging out company:", error);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user, setUser, 
        companyId,
        companyName,
        companyEmail,
        setCompanyId,
        setCompanyName,
        loginCompany,
        logoutCompany,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
